<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form" :model="formData" :rules="rules" ref="form" label-width="120px">
        <el-row>
          <el-col :span="12">
            <el-form-item prop="orderId" label="采购订单">
              <el-select @change="loadDeliveryList" v-model="formData.orderId" clearable filterable placeholder="请选择供应商">
                <el-option v-for="(item, index) of orderList" :value="item.orderId" :label="item.orderTitle + ' / ' + item.supplierName"
                  :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="deliveryId" label="提货单">
              <el-select v-model="formData.deliveryId" clearable filterable placeholder="请选择提货单">
                <el-option v-for="(item, index) of deliveryList" :value="item.deliveryId" :label="item.deliveryId"
                  :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="supplierId" label="供应商">
              <el-select v-model="formData.supplierId" clearable filterable placeholder="请选择供应商">
                <el-option v-for="(item, index) of gysArr" :value="item.userId" :label="item.userName"
                  :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="purchaseType" label="付款类型">
              <el-select v-model="formData.purchaseType" clearable filterable placeholder="请选择付款类型">
                <el-option v-for="(item, index) of typeArr" :value="item.value" :label="item.label"
                  :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row>

          <el-col :span="12">
            <el-form-item prop="purchaseDate" label="付款日期">
              <el-date-picker v-model="formData.purchaseDate" placeholder="请选择付款日期" type="date" clearable
                format="yyyy-MM-dd" value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>

          </el-col>

          <el-col :span="12">
            <el-form-item prop="purchasePrice" label="付款金额">
              <el-input-number v-model="formData.purchasePrice" />
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item prop="remark" label="备注说明">
              <el-input type="textarea" :autosize="{ minRows: 3 }" placeholder="请输入备注说明" v-model="formData.remark">
              </el-input>
            </el-form-item>
          </el-col>

        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="附件" prop="fileList">
              <file-upload v-model="formData.fileList" :maxSize="20"></file-upload>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>

              <el-button type="primary" @click="submit">保存</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>

export default {
  name: 'supplierPaymentAdd',
  data () {
    return {
      specList: [],
      supplierArr: [],
      formData: {
        deliveryId: '', // 提货ID
        orderId: '', // 订单ID
        supplierId: '',
        purchaseType: '',
        purchasePrice: '',
        purchaseDate: '',
        remark: '',
        fileList: []
      },
      rules: {
        orderId: [{ required: true, message: '请选择采购订单', trigger: 'change' }],
        supplierId: [{ required: true, message: '请选择供应商', trigger: 'change' }],
        purchaseType: [{ required: true, message: '请选择付款类型', trigger: 'change' }],
        purchasePrice: [{ required: true, message: '请输入付款价格', trigger: 'blur' }],
        purchaseDate: [{ required: true, message: '请选择付款日期', trigger: 'change' }]
        // remark: [{ required: true, message: '请输入备注说明', trigger: 'blur' }]
      },
      gysArr: [],
      typeArr: [
        {
          label: '保证金',
          value: '1'
        },
        {
          label: '货款',
          value: '2'
        },
        {
          label: '运费',
          value: '3'
        }
      ],
      orderList: [],
      deliveryList: []
    }
  },
  created () {
    this.loadUser()
    this.loadOrderList()
    if (this.priceId) {
      this.loadData()
    }
  },
  computed: {
    priceId () {
      return this.$route.query.priceId
    }
  },
  methods: {
    loadUser () {
      this.$axios.get(this.$apis.common.selectIparkUserByList, { userType: '4' }).then(res => {
        this.gysArr = res || []
      })
    },
    loadOrderList () {
      this.$axios.get(this.$apis.purchaseOrders.selectYcPurchaseOrderByList).then(res => {
        this.orderList = res.list || []
      })
    },
    loadDeliveryList(orderId) {
      this.$axios.get(this.$apis.purchaseDelivery.selectYcDeliveryByList, {
        params: {
          orderId
        }
      }).then(res => {
        this.deliveryList = res.list || []
      })
    },
    loadData () {
      this.$axios.get(this.$apis.supplierPayment.selectYcSupplierPriceByPriceId, {
        params: { priceId: this.priceId }
      }).then(res => {
        res.fileList = res.fileList ? res.fileList : []
        this.loadDeliveryList(res.orderId)

        this.formData = res || {}
      })
    },

    submit () {
      this.$refs.form.validate().then(() => {
        let url = this.$apis.supplierPayment.insertYcSupplierPrice
        if (this.priceId) {
          url = this.$apis.supplierPayment.updateYcSupplierPrice
        }

        this.$axios.post(url, this.formData).then(() => {
          this.$router.back()
        })
      })
    }
  }
}
</script>

<style scoped lang='scss'>
::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-input,
  .el-date-editor {
    width: 100%;
    max-width: 400px;

  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}
</style>
